<template>
  <div id="divContainer" v-on:click="exitmenu" class="page-effect">
    <!-- <TopMenu /> -->
    <section
      id="sectionId"
      class="d-flex"
      style="
        background-image: url('https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FBranding%2FEvent%20Background_2732x2048%20pixels.jpg?alt=media');
      "
    >
      <div>
        <a href="/roundtable" ><img :src ="imgURL" style="height : 100%; width: 100%"></a>
      </div>
    </section>
  </div>
</template>
<script>
import jQuery from "jquery";
let $ = jQuery;
export default {
  components: {},
  data() {
    return {
      imgURL: "https://resources.e2m.live/e2monair.appspot.com/temp%2FHB-coffee-bar.jpg?alt=media",
    };
  },
  mounted() {
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    $("#btnAddUserView").click();
    $("#imgBanner").attr("src", obj.EventBranding[0].banner);
    $("#topmenu").show();
  },
  methods: {
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
  },
};
</script>


<style scoped>
.full-page-frame {
  height: calc(100vh - 116px) !important;
  width: 100%;
}
.pl-80{
    padding-left: 80px;
}

/* Match the agenda inner-page shell: wrap the full-bleed lounge scene in a black
   frame + rounded card so the Engage@Event tab docks against the same black edge
   as on agenda. Using border (not margin/padding) keeps the section's existing
   fill height intact - no overflow / scrollbar. Outer radius 38 - 20px border =
   18px inner radius, matching the agenda card. Presentation only; no markup,
   data-flow, functionality or logic is changed. */
#divContainer {
  border: 20px solid #000 !important;
  border-radius: 38px !important;
  box-sizing: border-box !important;
  overflow: hidden !important;
}
</style>
